import { Select } from "antd"
import React from "react"

const SelectTypeSim = ({ value, onChange, disabled, style={ height: "36px"} }) => {
  return (
    <Select
      placeholder="Chọn loại SIM"
      title="Chọn loại SIM"
      allowClear
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={style}
    >
      <Select.Option value="esim">E-SIM</Select.Option>
      <Select.Option value="usim">Sim vật lý</Select.Option>
    </Select>
  )
}
export default SelectTypeSim
